import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a84e25d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-6 mb-4 card sm:p-8" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-main" }, "ข้อมูลสินค้า", -1))
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col gap-4 mt-4"
}
const _hoisted_6 = { class: "flex flex-1 space-x-4" }
const _hoisted_7 = ["src", "onerror"]
const _hoisted_8 = {
  class: "flex flex-col flex-1 w-1/3 text-justify",
  style: {"word-break":"break-word"}
}
const _hoisted_9 = { class: "text-base clamp-2" }
const _hoisted_10 = { class: "text-sm text-gray-400" }
const _hoisted_11 = { class: "flex flex-1 space-x-4" }
const _hoisted_12 = { class: "flex flex-col flex-1 gap-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-base text-gray-400" }, "ราคาต่อหน่วย", -1))
const _hoisted_14 = { class: "flex items-center h-full text-base" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-base text-gray-400" }, "จำนวน", -1))
const _hoisted_16 = { class: "relative flex flex-col items-center justify-end" }
const _hoisted_17 = { class: "relative flex items-center w-32 m-0 ng-star-inserted" }
const _hoisted_18 = {
  key: 0,
  class: "absolute left-0 flex-1 w-8 h-8 text-center cursor-pointer select-none",
  style: {"z-index":"15"}
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "z-10 flex-shrink-0 w-full text-center h-18" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-lg",
  for: "",
  style: {"color":"rgb(0, 0, 0)"}
}, null, -1))
const _hoisted_22 = { class: "relative my-2" }
const _hoisted_23 = ["onInput", "onChange", "onUpdate:modelValue"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "flex items-center justify-center h-full py-3 text-xl transition duration-300 ease-in-out bg-white border-2 rounded-md hover:border-blue-800 hover:text-blue-800" }, " + ", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 0,
  class: "absolute right-0 w-40 text-right text-gray-400 top-11"
}
const _hoisted_28 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "block lg:hidden" }, null, -1))
const _hoisted_30 = { class: "flex flex-1 space-x-0 lg:space-x-4" }
const _hoisted_31 = { class: "flex items-end justify-end flex-1 gap-4 lg:flex-col" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-base text-gray-400" }, "ราคารวม", -1))
const _hoisted_33 = { class: "flex items-center h-auto text-base lg:h-full sm:text-2xl lg:text-base text-green-island-600 lg:text-black" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pl-2 text-base text-gray-400" }, "บาท", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 rounded-md h-0.5 mx-6" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "bullet_main",
        src: require('@/assets/icon_bullet/product_info.svg'),
        alt: ""
      }, null, 8, _hoisted_3),
      _hoisted_4
    ]),
    (_ctx.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedArray(
          _ctx.data.products,
          _ctx.data.isVariant ? 'variantId' : 'productId'
        ), (product) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex flex-col gap-4 p-6 space-x-0 card lg:shadow-none lg:rounded-none lg:flex-row lg:space-x-4",
              key: product.productId
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  class: "object-contain w-16 h-16 rounded-md sm:w-28 lg:w-16 sm:h-28 lg:h-16",
                  src: _ctx.prefixUrlImage + 'public/' + product.productCoverUrl,
                  onerror: `this.src='${_ctx.envMedia}/public/icons/web/g_product.webp'`,
                  alt: ""
                }, null, 8, _hoisted_7),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(product.productName), 1),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(product.productSku), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.currency(product.productUnitPrice)), 1)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex flex-col items-center flex-1", !_ctx.data.isVariant ? '' : 'gap-4'])
                }, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      (!_ctx.data.isVariant)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("p", {
                              onClick: ($event: any) => (_ctx.deleteCount(product)),
                              class: "flex items-center justify-center h-full py-3 text-xl transition duration-300 ease-in-out bg-white border-2 rounded-md hover:border-blue-800 hover:text-blue-800"
                            }, " - ", 8, _hoisted_19)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", null, [
                          _hoisted_21,
                          _createElementVNode("div", _hoisted_22, [
                            (!_ctx.data.isVariant)
                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  autocomplete: "off",
                                  class: _normalizeClass(["w-full h-8 py-3 text-base text-center border-gray-200 rounded-md outline-none focus:outline-none focus:ring-transparent ng-untouched ng-pristine ng-valid ng-star-inserted", _ctx.data.isVariant ? 'border-none' : 'border-2']),
                                  type: "number",
                                  onInput: ($event: any) => (_ctx.calPrice(product)),
                                  onChange: ($event: any) => (_ctx.chkMin(product)),
                                  "onUpdate:modelValue": ($event: any) => ((product.productQty) = $event),
                                  id: "",
                                  placeholder: "",
                                  maxlength: "9"
                                }, null, 42, _hoisted_23)), [
                                  [_vModelText, product.productQty]
                                ])
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(product.productQty), 1)
                                ], 64))
                          ])
                        ])
                      ]),
                      (!_ctx.data.isVariant)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.plusCount(product)),
                            class: "absolute right-0 flex-1 w-8 h-8 text-center cursor-pointer select-none",
                            style: {"z-index":"15"}
                          }, _hoisted_26, 8, _hoisted_24))
                        : _createCommentVNode("", true)
                    ]),
                    (
                  product.useInventory &&
                  product.warehouse &&
                  !product.warehouse.hasKeepSelling &&
                  !_ctx.data.isVariant
                )
                      ? (_openBlock(), _createElementBlock("small", _hoisted_27, [
                          (_ctx.stock(product) > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" จำนวนสินค้า " + _toDisplayString(_ctx.stock(product) || 0) + " " + _toDisplayString(product.productUnit), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock("span", _hoisted_28, "สินค้าหมด"))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 2)
              ]),
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("div", _hoisted_33, [
                    _createTextVNode(_toDisplayString(_ctx.currency(product.itemsPriceRow)) + " ", 1),
                    _hoisted_34
                  ])
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _hoisted_35
  ]))
}